import { itx } from "../../translationItx/itx";
import guideSequence_addActorElcbTerminalStrip from "../sequences/guideSequence_addActorElcbTerminalStrip";
import guideSequence_addFuse from "../sequences/guideSequence_addFuse";
import guideSequence_addFuseToConsumer from "../sequences/guideSequence_addFuseToConsumer";
import guideSequence_addTerminal from "../sequences/guideSequence_addTerminal";
import { ToDoItem } from "../ToDoItem";
import storyLines_Framework from "./Framework";
import StoryLine_BaseIntroduction from "./BaseIntroduction";
import StoryLine from "./StoryLine";
import guideSequence_addTerminalToConsumer from "../sequences/guideSequence_addTerminalToConsumer";

class StoryLine_CabinetPlanning extends StoryLine {
  className = "CabinetPlanning"; // no itx

  firstItem = (): ToDoItem => {
    return this.createELCB();
  };

  description = () => {
    return itx("guideState.cabinetPlaning");
  };
  ///////////////////////////////////////////////////////////////////////
  // GuideState.cabinetPlaning
  ///////////////////////////////////////////////////////////////////////
  createELCB = (): ToDoItem => {
    return new ToDoItem({
      id: "createELCB",
      text: itx("ToDoItemLine.createELCB"),
      subSteps: undefined,
      nextStep: this.createFuse,
      hasToBeDoneBevoreStep: [StoryLine_BaseIntroduction.createCabinet],
      done: (lastToDoElement?: ToDoItem) => {
        return state.allELCBs().length > 0;
      },
      typeForPattern: "ELCB", // no itx
      pattern: guideSequence_addActorElcbTerminalStrip,
      prio: 24,
    });
  };
  ////////////////////////////////////////////////////////////////////////
  createFuse = (): ToDoItem => {
    return new ToDoItem({
      id: "createFuse",
      text: itx("ToDoItemLine.createFuse"),
      subSteps: undefined,
      nextStep: this.connectionConsumerWithFuse,
      hasToBeDoneBevoreStep: [this.createELCB],
      done: (lastToDoElement?: ToDoItem) => {
        return state.allFuses().length > 0;
      },
      pattern: guideSequence_addFuse,
      prio: 25,
    });
  };
  ////////////////////////////////////////////////////////////////////////
  connectionConsumerWithFuse = (): ToDoItem => {
    return new ToDoItem({
      id: "connectionConsumerWithFuse",
      text: itx("ToDoItemLine.connectionConsumerWithFuse"),
      nextStep: this.createTerminalStrip,
      subSteps: undefined,
      hasToBeDoneBevoreStep: [this.createFuse, StoryLine_BaseIntroduction.createConsumer],
      done: (lastToDoElement?: ToDoItem) => {
        let res = false;
        state.allConsumers().forEach((consumer) => {
          if (consumer.fuse) {
            res = true;
          }
        });
        return res;
      },
      pattern: guideSequence_addFuseToConsumer,
      prio: 26,
    });
  };
  ////////////////////////////////////////////////////////////////////////
  createTerminalStrip = (): ToDoItem => {
    return new ToDoItem({
      id: "createTerminalStrip",
      text: itx("ToDoItemLine.createTerminalStrip"),
      subSteps: undefined,
      nextStep: this.createTerminal,
      hasToBeDoneBevoreStep: [StoryLine_BaseIntroduction.createCabinet],
      done: (lastToDoElement?: ToDoItem) => {
        return state.allTerminalStrips().length > 0;
      },
      typeForPattern: "TerminalStrip", // no itx
      pattern: guideSequence_addActorElcbTerminalStrip,
      prio: 27,
    });
  };
  ////////////////////////////////////////////////////////////////////////
  createTerminal = (): ToDoItem => {
    return new ToDoItem({
      id: "createTerminal",
      text: itx("ToDoItemLine.createTerminal"),
      subSteps: undefined,
      nextStep: this.connectionConsumerWithTerminal,
      hasToBeDoneBevoreStep: [this.createTerminalStrip],
      done: (lastToDoElement?: ToDoItem) => {
        return state.allTerminals().length > 0;
      },
      pattern: guideSequence_addTerminal,
      prio: 28,
    });
  };
  ////////////////////////////////////////////////////////////////////////
  connectionConsumerWithTerminal = (): ToDoItem => {
    return new ToDoItem({
      id: "connectionConsumerWithTerminal",
      text: itx("ToDoItemLine.connectionConsumerWithTerminal"),
      nextStep: storyLines_Framework.select_A,
      subSteps: undefined,
      hasToBeDoneBevoreStep: [this.createTerminal, StoryLine_BaseIntroduction.createConsumer],
      done: (lastToDoElement?: ToDoItem) => {
        let res = false;
        state.allConsumers().forEach((consumer) => {
          if (consumer.terminal) {
            res = true;
          }
        });

        return res;
      },
      pattern: guideSequence_addTerminalToConsumer,
      ///////////////////hier fehlt noch pattern
      prio: 29,
    });
  };
}

const storyLine_CabinetPlanning = new StoryLine_CabinetPlanning();
export default storyLine_CabinetPlanning;
